import type { TableCommandFactory } from 'components/Table/model/TableModel';

export const deselectAllTableRows: TableCommandFactory = (cmdContext) => () => {
  cmdContext.updateState((draft) => {
    draft.selectedRows.clear();
    draft.allRowsSelectState = 'unchecked';
  });
};
